import styled from "@emotion/styled";
import { useState } from "react";
import moment from "moment";

import logoSocioIcon from "../../assets/avantiicon.png";
import FormHelper from "../../utils/FormHelper";
import FormBox from "../../components/LoginBox/FormBox";
import Form from "../../components/LoginBox/Form";
import { BREAKPOINTS } from "../../utils/consts";
import { HEROKU_AVANTI_LOGIN, HEROKU_USER_DATA_AVANTI } from "../../utils/URLconsts";

const LoginAvantiFormPopup = (props) => {
  const { dataHelper, userHelper, location, navigate, popup, message, config } =
    props;

  const inputs = AvantiForm();

  const [loading, setLoading] = useState(0);

  const getAvantiUserData = async (userId) => {
    const postAvantiUserDataUrl = await dataHelper.getHerokuUrlV2(
      HEROKU_USER_DATA_AVANTI
    );
    const response = await await dataHelper.api.post(postAvantiUserDataUrl, {
      userId,
    });

    const getAvantiUserData = await response.json();

    return getAvantiUserData
  };

  const handleLogin = async ({ SocioEmail, SocioPassword }) => {
    const postUrl = await dataHelper.getHerokuUrlV2(HEROKU_AVANTI_LOGIN);

    popup.setIsLoading(true);
    await dataHelper.api
      .post(postUrl, {
        email: SocioEmail,
        password: SocioPassword,
      })
      .then((response) => response.json())
      .then(async ({ data }) => {
        const code = data?.Result.Info;
        const userData = data?.Result?.Account;

        switch (code) {
          case 1:
            if (userData) {
              const token = await userHelper?.getUserToken(userData?.Email);

              if (token) {
                popup.setIsOpen(false);
                return navigate(`${"/sso"}?token=${token}`);
              } else {
                const avantiResponse = await getAvantiUserData(userData?.UserId)

                if (avantiResponse?.code !== 1) {
                  return message.add({
                    type: "error",
                    message:
                      "Não foi possível processar sua requisição. Por favor, tente novamente mais tarde.",
                  });
                }

                const avantiUserData = avantiResponse?.data?.Result

                const birthdate = avantiUserData
                  ? moment(avantiUserData?.BirthDate).format("DD/MM/YYYY")
                  : null;

                let signUpParams = {
                  email: userData?.Email,
                  firstName: avantiUserData?.FirstName,
                  lastName: avantiUserData?.LastName,
                  cpf: avantiUserData?.Identifier,
                  birthdate,
                  socialType: "Avanti",
                  socialData: {
                    // accessToken: result?.signInResult?.user?.accessToken,
                  },
                };

                popup.setIsOpen(false);
                return navigate("/cadastro", { state: signUpParams });
              }
            
            } else {
              return message.add({
                type: "error",
                message:
                  "Não foi possível processar sua requisição. Por favor, tente novamente mais tarde.",
              });
            }
          case 4:
            return message.add({
              type: "error",
              message: "E-mail ou senha incorretos.",
            });
          case 5:
            return message.add({
              type: "error",
              message:
                "Você ainda não confirmou sua conta, verifique seu e-mail.",
            });
          default:
            return message.add({
              type: "error",
              message: "Sistema indisponível, tente novamente mais tarde.",
            });
        }
      })
      .catch((error) => {
        message.add({
          type: "error",
          message: "Sistema indisponível, tente novamente mais tarde.",
        });
        console.error(error);
      })
      .finally(() => {
        popup.setIsLoading(false);
      });
  };

  return (
    <StyledAvantiLoginPopup>
      <div className="avanti-tag">
        <img src={logoSocioIcon} className="avanti-icon" alt="avanti logo" />
      </div>
      <span className="avanti-subtitle">Acesse com sua conta Avanti:</span>
      <FormBox
        {...props}
        className="content-form"
        inside={
          <>
            <Form
              navigate={navigate}
              location={location}
              dataHelper={dataHelper}
              config={config}
              inputs={inputs}
              handleSend={handleLogin}
              loading={loading}
              setLoading={setLoading}
            />
          </>
        }
      />
    </StyledAvantiLoginPopup>
  );
};

export default LoginAvantiFormPopup;

/* form */

const AvantiForm = (props) => {
  return {
    SocioEmail: FormHelper.useFormInput({
      id: "socio-email",
      label: "E-mail",
      type: "text",
      validations: [
        {
          type: "required",
          errorMessage: "Digite um e-mail",
        },
        {
          type: "email",
          errorMessage: "Digite um endereço de e-mail válido",
        },
      ],
      inputOptions: {
        spellCheck: false,
      },
      mask: "email",
    }),
    SocioPassword: FormHelper.useFormInput({
      id: "socio-password",
      label: "Senha",
      type: "password",
      validations: [
        {
          type: "required",
          errorMessage: "Digite sua senha",
        },
      ],
    }),
    SocioTermsConfirmation: FormHelper.useFormInput({
      id: "socio-terms-confirmation",
      // label: "<p>teste <a href='https://google.com'>link</a></p>",
      label: `Li e aceito os <a href="${"https://appoficial-arquivos.s3.sa-east-1.amazonaws.com/Termos_app/SEP+TERMOS+DE+USO.pdf"}" target="_blank" style="text-decoration: underline; font-weight: bold;">Termos e Condições</a> e a <a href="${"https://appoficial-arquivos.s3.sa-east-1.amazonaws.com/Termos_app/20210910+PALMEIRAS+-+Pol%C3%ADtica+de+Privacidade+e+Confidencialidade+(sem+Cookies)+complementada.pdf"}" target="_blank" style="text-decoration: underline; font-weight: bold;">Política de Privacidade de dados</a>`,
      type: "checkbox",
      validations: [
        {
          type: "required",
          errorMessage: "Marque a caixa de seleção para continuar",
        },
      ],
    }),
  };
};

const StyledAvantiLoginPopup = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 586px;
  padding: 48px;
  gap: 48px;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #006e3d;

  @media (max-width: ${BREAKPOINTS.PHONE}px) {
    padding: 16px;
  }

  .avanti-tag {
    align-self: center;
    padding: 8px 16px;
    background-image: linear-gradient(
      to right,
      #006e3d 0%,
      rgba(0, 110, 61, 1) 100%
    );
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    width: 100%;
    
    @media (max-width: 768px) {
      width: 90%;
    }
    .avanti-icon {
      width: 90%;
    }
  }

  .content-form {
    width: auto !important;

    .error {
      display: flex;
    }
  }

  .avanti-title {
    font-family: "Roboto Condensed";
    font-size: 38px;
    line-height: 49px;
    font-weight: bold;
    text-transform: uppercase;
    color: #006e3d;
  }

  .avanti-subtitle {
    font-family: "Roboto Condensed";
    font-size: 21px;
    line-height: 33px;
    font-weight: 400;
    color: #006e3d;
  }
`;
